export default __webpack_public_path__ + "static/media/photo--lg--139.968cb3e0.jpg";